import { render } from "./News.vue?vue&type=template&id=61b6fab3"
import script from "./News.vue?vue&type=script&lang=ts"
export * from "./News.vue?vue&type=script&lang=ts"
script.render = render

export default script